class MainProduct extends HTMLElement {
  /**
   * An abort controller for the active fetch (if there is one)
   * @type {AbortController | null}
   */
  activeFetch = null;

  constructor() {
    super();
  }
  
  get productForm() {
    return this.querySelector(`product-form`);
  }

  connectedCallback() {
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.querySelector('.product-info__variant-selects')?.addEventListener('change', this.handleVariantChange);
  }
  
  disconnectedCallback() {
    this.querySelector('.product-info__variant-selects')?.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange(event) {
    this.resetProductFormState();

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map(({ dataset }) => dataset.optionValueId);

    const productUrl = event.target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    this.pendingRequestUrl = productUrl;
    const shouldFetchFullPage = this.dataset.url !== productUrl;

    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
      targetId: event.target.id,
      callback: shouldFetchFullPage
        ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
        : this.handleUpdateProductInfo(productUrl),
    });
  }

  resetProductFormState() {
    this.productForm?.toggleSubmitButton(true);
    this.productForm?.handleErrorMessage();
  }

  buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
    const params = [];

    !shouldFetchFullPage && params.push(`section_id=${this.dataset.section}`);

    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }

    return `${url}?${params.join('&')}`;
  }

  renderProductInfo({ requestUrl, targetId, callback }) {
    this.activeFetch?.abort();
    this.activeFetch = new AbortController();

    fetch(requestUrl, { signal: this.activeFetch.signal })
      .then((response) => response.text())
      .then((responseText) => {
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSwapProduct(productUrl, updateFullPage) {
    return (html) => {
      const variant = this.getSelectedVariant(html.querySelector('product'));
      this.updateURL(productUrl, variant?.id);

      if (updateFullPage) {
        document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

        // might have to change later if add scripts to product page since by default, scripts are disabled when using element.innerHTML.
        document.querySelector('main').innerHTML = html.querySelector('main').innerHTML;
      } else {
        document.querySelector('product').innerHTML = html.querySelector('product').innerHTML;
      }
    };
  }

  handleUpdateProductInfo(productUrl) {
    return (html) => {
      const variant = this.getSelectedVariant(html);
      this.updateURL(productUrl, variant?.id);

      if (!variant) {
        this.setUnavailable();
        return;
      }

      if (variant?.featured_media?.id != this.getSelectedVariant(this)?.featured_media?.id) {
        this.updateFeaturedMedia(html);
      }


      this.updateOptionValues(html);
      this.updatePrice(html);
      this.updateForms(html);
    };
  }

  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('[data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  updateURL(url, variantId) {
    window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
  }

  updateOptionValues(html) {
    const variantSelects = html.querySelector('.product-info__variant-selects');
    if (variantSelects && document.querySelector('.product-info__variant-selects')) {
      document.querySelector('.product-info__variant-selects').innerHTML = variantSelects.innerHTML;
    }
  }

  updatePrice(html) {
    const price = html.querySelector('.product-info__price');
    if (price && document.querySelector('.product-info__price')) {
      document.querySelector('.product-info__price').innerHTML = price.innerHTML;
    }
  }

  updateForms(html) {
    const forms = html.querySelector('.product-info__form');
    if (forms && document.querySelector('.product-info__form')) {
      document.querySelector('.product-info__form').innerHTML = forms.innerHTML;
    }
  }

  updateFeaturedMedia(html) {
    const featuredMedia = html.querySelector(".main-product__featured-media");
    if (featuredMedia && document.querySelector('.main-product__featured-media')) {
        document.querySelector('.main-product__featured-media').innerHTML = featuredMedia.innerHTML;
    }
  }

  setUnavailable() {
    this.productForm?.toggleSubmitButton(true, 'Unavailable');
  }
}

customElements.define('main-product', MainProduct);
